import React, { FC, useState, useEffect } from 'react'
import styles from 'styles/components/template.module.scss'
import { State } from 'index'
import { useSelector } from 'react-redux'
import { NavButton } from 'components/Button'
import { MessageList } from 'components/List'
import { Pagination } from 'components/Pagination'
import { Spacer } from 'components/Utility'
import { PER_PAGE } from 'constants/message'
import { getStoreRef } from 'reducks/auth/selectors'
import { fetchCustomerMessages } from 'repos/message'
import { MessageType as BaseMessageType } from 'types/message'
import { FirebaseDocRefType } from 'firebase'

type MessageType = BaseMessageType & { ref: FirebaseDocRefType }

const MessageListTemplate: FC = () => {
  const storeRef = useSelector((state: State) => getStoreRef(state))
  const query = useSelector((state: State) => state.router.location.query)
  const currentPage = Number(query?.page ?? '1')

  const [messages, setMessages] = useState<MessageType[]>([])

  const totalCustomerMessages = messages.length ?? 0

  const startIndex = (currentPage - 1) * PER_PAGE
  const endIndex = Math.min(startIndex + PER_PAGE, totalCustomerMessages)
  const Messages = messages.slice(startIndex, endIndex)

  useEffect(() => {
    ;(async () => {
      const messages = await fetchCustomerMessages(storeRef)
      setMessages(messages)
    })()
  }, [])

  return (
    <div className={styles.standard}>
      <Spacer size={40} />
      <MessageList messages={Messages} isAdminNotification={false} />
      <Pagination perPage={PER_PAGE} total={totalCustomerMessages} />
      <Spacer size={24} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={40} />
    </div>
  )
}

export default MessageListTemplate
